import Typography from "../Typography";
import SemiCircleChart, { SemiCircleChartDataItem } from "../SemiCircleChart";

type ReportingGaugeCardProps<T> = {
    title: string;
    data: SemiCircleChartDataItem<T>[];
    onSectorClick?: (payload: SemiCircleChartDataItem<T>) => void;
};

const ReportingSemiCircleChartCard = <T,>({
    title,
    data,
    onSectorClick,
}: ReportingGaugeCardProps<T>) => {
    return (
        <div className="py-4 px-6 bg-surface-light-1 rounded-xl">
            <Typography
                variant="body-large"
                component="h3"
                className="mb-5 font-medium"
            >
                {title}
            </Typography>
            <SemiCircleChart data={data} onSectorClick={onSectorClick} />
        </div>
    );
};

export default ReportingSemiCircleChartCard;
